import { api } from '@/lib/api';
import type { TrainerDetailsRequest, TrainerDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/trainer';

export async function save_trainer_details(
  input: TrainerDetailsRequest,
): Promise<TrainerDetailsResponse> {
  const res = await api.post<TrainerDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_trainer_details(): Promise<TrainerDetailsResponse | null> {
  const res = await api.get<TrainerDetailsResponse | null>(URL);
  return res.data;
}
